import React from 'react';
import { Brain, ShieldAlert, Zap } from 'lucide-react';
export function ReframeSection() {
  return <section className="py-4 px-4 md:px-12 lg:px-24 bg-[#0a0c0e] border-t border-card-border" data-id="element-321">
      <div className="max-w-4xl mx-auto text-center" data-id="element-322">
        <div className="inline-flex items-center justify-center p-3 bg-alert-red/10 rounded-full mb-6" data-id="element-323">
          <ShieldAlert className="w-8 h-8 text-alert-red" data-id="element-324" />
        </div>

        <h2 className="font-bebas text-4xl md:text-6xl text-white mb-8" data-id="element-325">
          No fallaste tú.{' '}
          <span className="text-alert-red" data-id="element-326">Tu método estaba roto.</span>
        </h2>

        <p className="font-inter text-lg md:text-xl text-text-muted mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-327">
          La industria habla de 'sanar raíces' o 'fuerza de voluntad'. Nosotros
          hablamos de <strong className="text-white" data-id="element-328">Biología Hardcore</strong>.
          Ese hábito nocturno hackea tu sistema de dopamina. Intentar dejarlo
          con 'ganas' es como poner. cinta adhesiva sobre la luz de 'Falla de
          Motor'. El motor se sigue quemando por dentro.
        </p>
        <p className="text-white font-semibold text-xl text-left border-l-4 border-alert-red pl-4 py-1" data-id="element-329">
          ❌ EL PROBLEMA DE LOS MÉTODOS TRADICIONALES:
        </p>
        <br data-id="element-330" />
        <p className="text-text-muted font-inter text-left" data-id="element-331">
          <strong className="text-white font-bold" data-id="element-332">•</strong> Tratan el problema
          como "falta de carácter" cuando es una LESIÓN NEUROLÓGICA - Los
          pecados requieren perdón, las lesiones requieren sanación
        </p>
        <br data-id="element-333" />
        <p className="text-text-muted font-inter  text-left" data-id="element-334">
          <strong className="text-white font-bold" data-id="element-335"> •</strong> Refuerzan el
          mismo ciclo de recaída - La fuerza de voluntad ACTUALMENTE fortalece
          el bucle neurológico
        </p>
        <br data-id="element-336" />
        <p className="text-text-muted font-inter  text-left" data-id="element-337">
          <strong className="text-white font-bold" data-id="element-338">•</strong> Te atrapan en la
          espiral de vergüenza - Un desliz y "fallaste de nuevo", llevándote al
          aislamiento
        </p>
        <br data-id="element-339" />
        <p className="text-white font-semibold text-xl text-left border-l-4 border-alert-red pl-4 py-1" data-id="element-340">
          ✅ ASÍ ES COMO EL PROTOCOLO DE BLINDAJE LO RESUELVE:
        </p>
        <br data-id="element-341" />
        <p className="text-text-muted font-inter text-left" data-id="element-342">
          Identifica la "Raíz del Secuestro" - Trazamos el origen neurológico
          que genera tus impulsos - - antes de que intentes controlar el
          comportamiento.
        </p>
        <br data-id="element-343" />
        <p className="text-text-muted font-inter  text-left" data-id="element-344">
          Sana la Fuente - No gestionamos síntomas. Aplicamos sanación directa a
          la raíz para que pierda su poder.
        </p>
        <br data-id="element-345" />
        <p className="text-text-muted font-inter  text-left" data-id="element-346">
          Reconstruye tu Identidad - Recuperas la coherencia entre quien eres de
          día y de noche - para que la libertad sea tu estado natural.
        </p>
        <br data-id="element-347" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto" data-id="element-348">
          {/* Hardware Dañado */}

          {/* Sistema Blindado */}
        </div>
      </div>
    </section>;
}